import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  maxWidth: "20rem",
  bgcolor: "background.default",
  boxShadow: 24,
  padding: "2rem 1rem",
  display: "flex",
  flexDirection: "column",
  borderRadius: "1rem",
  outline: "none",
};
interface Props {
  title: string;
  description?: string;
  open: boolean;
  handleClose: () => void;
  children: React.ReactNode;
}
export default function ModalComponent(props: Props) {
  const { title, description, open, handleClose, children } = props;

  return (
    <Modal
      aria-labelledby={title}
      aria-describedby={description || title}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 300,
          sx: {
            backdropFilter: "blur(4px)",
          },
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style}>{children}</Box>
      </Fade>
    </Modal>
  );
}
